import { h } from 'preact';
import React, { Component, Fragment } from 'react';
import { render } from 'react-dom';
import { formatMoney } from "@shopify/theme-currency/currency";

import { debounce } from "debounce";
import { Connect, Provider } from "redux-zero/preact";
import { Scrollbar } from "react-scrollbars-custom";
import { store } from "./store";
import actions from "./actions";
import CartPopupItem from "./CartPopupItem";

class CartPopup extends Component {
  constructor(props) {
    super(props);
    this.state = { scrolled: false, isMobile: false };
  }
  
  componentDidMount() {
    document.body.addEventListener('click', (e) => this.initCloseEvent(e))
    window.addEventListener("resize", debounce(this.resize.bind(this), 300));
    this.resize();
  }
  
  resize() {
    let isMobile = (window.innerWidth <= 1199);
    if (isMobile !== this.state.isMobile) {
      this.setState({ isMobile });
    }
  }
  
  
  componentWillUnmount() {
    window.removeEventListener("resize", this.resize.bind(this));
  }
  
  componentDidUpdate(prevProps) {
    if (prevProps.popupActive !== this.props.popupActive) {
      if ($(window).scrollTop() > 0) {
        this.setState({ scrolled: true });
      } else {
        this.setState({ scrolled: false });
      }
    }
  }
  
  initCloseEvent(e) {
    if (e.target.closest(`.cart-popup`) || e.target.closest('.header__cart-btn') || e.target.classList.contains('cart-popup')) {
      return;
    }
    this.props.closeMinicart();
  }
  
  renderEmptyCart() {
    return (
      <div class="cart-popup__empty">
        <div class="cart-popup__empty-box">
          <p>{ theme.cart.empty }</p>
          <a href={ theme.cart.continue_shopping_link }
             class="button w-100 mb-0">{ theme.cart.continue_shopping_label }</a>
        </div>
      </div>
    )
  }
  
  renderMobilePopup() {
    const { justAdded } = this.props;
    return (
      <div className={ this.getClasses() }>
        <div className="cart-popup__mobile text-right">{ justAdded.title + ' ' + theme.cart.added }</div>
      </div>
    )
  }
  
  getClasses() {
    let active = this.props.popupActive ? ' active' : '';
    let scrolled = this.state.scrolled ? ' cart-popup--scrolled' : '';
    return "cart-popup" + active + scrolled;
  }
  
  renderCartItems() {
    const { items, updateItem, removeItem, cart } = this.props;
    return (
      <Fragment>
        <Scrollbar style={ { width: '100%', height: 432 } }>
          <div class="cart-popup__holder">
            { items.map(item => (
              <CartPopupItem key={ item.key } item={ item } updateItem={ updateItem } removeItem={ removeItem }/>
            )) }
          </div>
        </Scrollbar>
        <form class="cart-popup__footer">
          <div class="cart-form__total">
            <div class="row">
              <div class="col-8">
                <p>{ theme.cart.total }</p>
              </div>
              <div class="col-4 text-right">
                <p>{ formatMoney(cart.total_price, theme.moneyFormat) }</p>
              </div>
            </div>
          </div>
          <a href="/checkout" type="submit" class="button w-100">{ theme.cart.checkout }</a>
          <a href="/cart" class="button button--secondary w-100">{ theme.cart.view_bag }</a>
        </form>
      </Fragment>
    )
  }
  
  renderDesktopPopup() {
    const { items } = this.props;
    return (
      <div class={ this.getClasses() }>
        <div
          class={ 'd-flex flex-column justify-content-between h-100' + items.length ? ' justify-content-between' : '' }>
          <div class="cart-popup__header">
            <div class="h5 m-0 cart-popup__title">{ theme.cart.title }</div>
          </div>
          { items.length > 0 && this.renderCartItems() }
          { items.length > 0 || this.renderEmptyCart() }
        </div>
      </div>
    )
  }
  
  render({ cart, justAdded, item_count, closePopup, popupActive, items, updateItem, removeItem }) {
    return this.state.isMobile && this.renderMobilePopup() || this.renderDesktopPopup();
  }
}

let ref = document.querySelector('#cart-popup')
if (ref) {
  render(
    <Provider store={ store }>
      <Connect actions={ actions }>
        { (props) => (
          <CartPopup { ...props }/>
        ) }
      </Connect>
    </Provider>, ref
  )
}

